import React from 'react';
import { Link } from 'react-router-dom';
import { isOrderHost } from '../../utils/hostRouting';

// Renders as an in-app <Link to="/"> normally, but as a hard <a> to the
// marketing site when running on order.effyventure.com — "/" there is the
// login page, not the marketing home page, so it needs a real cross-domain link.
export default function BrandHomeLink({ className, children }) {
  if (isOrderHost()) {
    return <a href="https://effyventure.com" className={className}>{children}</a>;
  }
  return <Link to="/" className={className}>{children}</Link>;
}
